import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

class MatterQuestionsTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      question_id: null,
      lista_questoes: [],
      qntd_questoes: [],
      qntd_questoes_categoria: [],
      dados: [],
    };
    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionarQuestao = this.adicionarQuestao.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.questoes) && Array.isArray(newProps.lista_questoes)) {
      this.setState({dados: newProps.questoes, lista_questoes: newProps.lista_questoes, qntd_questoes: newProps.qntd_questoes, qntd_questoes_categoria: newProps.qntd_questoes_categoria});
    }
  }

  adicionarQuestao(event) {
    event.preventDefault();
    var datasave = {
      question_id: this.state.question_id,
      matter_id: this.props.matter_id,
    };
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/materia/questao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshTable(responseJson);
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      /*<BotaoDeletar url={"/materia/questao/"+ cell} />*/
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var matter_question_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa questão?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/materia/questao/' + matter_question_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deletarLinha(matter_question_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(matter_question_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == matter_question_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.adicionarQuestao}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Questões:</label>
            <Select
              className="form-field-name"
              name="question_id"
              value={this.state.question_id}
              searchable={true}
              multi={true}
              placeholder={'Selecionar Questões'}
              onChange={this.handleSelectChange.bind(this, 'question_id')}
              options={this.state.lista_questoes}
            />    
        </div>
      </div>
      <div className="col-md-6">
        <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar questão</button>
      </div>
    </div>
  </form>
  <hr/>
  <table className="table tabela-questao-opcoes">
    <thead>
      <tr>
        <td>Dificuldade</td>
        <td>Quantidade</td>
      </tr>
    </thead>
    <tbody>
      {Object.keys(self.state.qntd_questoes).map(function(k) {
        return (
          <tr>
            <td>{self.state.qntd_questoes[k].name}</td>
            <td>{self.state.qntd_questoes[k].qtd}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
  <hr/>
  <table className="table tabela-questao-opcoes">
    <thead>
      <tr>
        <td>Categoria</td>
        <td>Quantidade</td>
      </tr>
    </thead>
    <tbody>
      {Object.keys(self.state.qntd_questoes_categoria).map(function(k) {
        return (
          <tr>
            <td>{self.state.qntd_questoes_categoria[k].name}</td>
            <td>{self.state.qntd_questoes_categoria[k].qtd}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há questões cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="questao" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Questão</TableHeaderColumn>
    
    <TableHeaderColumn dataField="dificuldade" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Dificuldade</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default MatterQuestionsTab;



// WEBPACK FOOTER //
// ./src/Components/Matters/Elements/MatterQuestionsTab.js